import { useCallback, useEffect, useState } from "react";
import api, { API_ORIGIN, getAllRecords } from "../api";
const money = (v) => `₹${Number(v || 0).toLocaleString("en-IN")}`;
function Proof({ payment, close, saved }) {
  const [file, setFile] = useState(null),
    [reference, setReference] = useState(""),
    [error, setError] = useState(""),
    [saving, setSaving] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!file) return setError("Select a proof photo.");
    setSaving(true);
    try {
      const data = new FormData();
      data.append("paymentProof", file);
      data.append("paymentReferenceNumber", reference);
      await api.post(`/payments/${payment._id}/payment-proof`, data);
      saved();
      close();
    } catch (err) {
      setError(err.response?.data?.message || "Unable to save payment proof.");
    } finally {
      setSaving(false);
    }
  };
  return (
    <div className="fuel-modal-backdrop">
      <form
        className="fuel-modal"
        onSubmit={submit}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <header>
          <div>
            <p>PAYMENT PROOF</p>
            <h3>{payment.vehicleNo}</h3>
          </div>
          <button type="button" onClick={close}>
            ×
          </button>
        </header>
        <div className="fuel-form-grid">
          <label>
            Payment Reference No.
            <input
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              required
            />
          </label>
          <label>
            Proof Photo
            <input
              type="file"
              accept="image/jpeg,image/png,image/webp"
              onChange={(e) => setFile(e.target.files[0])}
              required
            />
            <small>JPG, PNG, or WebP</small>
          </label>
          {error && <p className="fuel-error">{error}</p>}
        </div>
        <footer>
          <button type="button" className="cancel" onClick={close}>
            Cancel
          </button>
          <button disabled={saving}>
            {saving ? "Saving…" : "Mark Payment Done"}
          </button>
        </footer>
      </form>
    </div>
  );
}
export default function CompanyPaymentsPage() {
  const [items, setItems] = useState([]),
    [message, setMessage] = useState(""),
    [proof, setProof] = useState(null);
  const load = useCallback(async () => {
    try {
      setItems(await getAllRecords("/payments"));
    } catch (e) {
      setMessage(e.response?.data?.message || "Unable to load payments.");
    }
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  return (
    <article className="portal-module">
      <p>PAYMENTS</p>
      <h2>Ad Hoc Vehicle Payments</h2>
      <span>Upload payment proof to mark a pending payment as done.</span>
      {message && <div className="fuel-notice">{message}</div>}
      <div className="fuel-table action-table">
        <table>
          <thead>
            <tr>
              {[
                "Vehicle",
                "Vendor",
                "Client location",
                "Amount",
                "Status",
                "Action",
              ].map((x) => (
                <th key={x}>{x}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {items.map((x) => (
              <tr key={x._id}>
                <td>{x.vehicleNo || "—"}</td>
                <td>{x.vendorName}</td>
                <td>{x.routeLocation || "—"}</td>
                <td>{money(x.totalAmount)}</td>
                <td>
                  {x.paymentStatus === "paid"
                    ? "Payment Done"
                    : x.paymentStatus}
                </td>
                <td>
                  {x.paymentStatus === "pending" ? (
                    <button onClick={() => setProof(x)}>Proof</button>
                  ) : x.paymentProof ? (
                    <a
                      href={`${API_ORIGIN}${x.paymentProof}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      View proof
                    </a>
                  ) : (
                    "—"
                  )}
                </td>
              </tr>
            ))}
            {!items.length && (
              <tr>
                <td colSpan="6">No payment requests found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {proof && (
        <Proof
          payment={proof}
          close={() => setProof(null)}
          saved={() => {
            setMessage("Payment Done.");
            load();
          }}
        />
      )}
    </article>
  );
}
